import { useSyncExternalStore } from "react";

/** Off switch for single-key shortcuts such as "?" (WCAG 2.1.4). Kept per browser; on by default. */
export const CHARACTER_KEYS_STORAGE_KEY = "magicbi.commands.characterKeys";
const listeners = new Set<() => void>();
let cached: boolean | null = null;

const readStored = (): boolean => {
  try {
    return window.localStorage.getItem(CHARACTER_KEYS_STORAGE_KEY) !== "off";
  } catch {
    return true;
  }
};

export const getCharacterKeysEnabled = (): boolean => {
  if (cached === null) cached = readStored();
  return cached;
};

export const setCharacterKeysEnabled = (enabled: boolean): void => {
  cached = enabled;
  try {
    if (enabled) window.localStorage.removeItem(CHARACTER_KEYS_STORAGE_KEY);
    else window.localStorage.setItem(CHARACTER_KEYS_STORAGE_KEY, "off");
  } catch { /* storage unavailable: the choice lasts for this page only */ }
  listeners.forEach((listener) => listener());
};

/** Forget the in-memory value so the next read goes to storage (tests). */
export const resetCharacterKeysCache = (): void => { cached = null; };

export const subscribeCharacterKeys = (listener: () => void): (() => void) => {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
};

/** `[on, setOn]` for a Switch in the shortcuts dialog. */
export const useCharacterKeys = (): [boolean, (enabled: boolean) => void] =>
  [useSyncExternalStore(subscribeCharacterKeys, getCharacterKeysEnabled), setCharacterKeysEnabled];
